import SendMoneyForm from 'pages/Money/SendMoneyForm';

function SendMoney() {
    return (
        <div>
            <SendMoneyForm />
        </div>
    );
}

export default SendMoney;
